import { render } from "./TSComponentOptionsApi.vue?vue&type=template&id=62f8585d"
import script from "./TSComponentOptionsApi.vue?vue&type=script&lang=ts"
export * from "./TSComponentOptionsApi.vue?vue&type=script&lang=ts"
script.render = render

export default script